import React from 'react';
import {RouteComponentProps} from 'react-router';
import {withRouter} from 'react-router';

function withRouterRef<TProps, TRefElement = any>(
    WrappedComponent: React.ComponentType<TProps & RouteComponentProps & {forwardRef: TRefElement}>
) {
    const WithRouter = withRouter(WrappedComponent);
    const WithRouterRef = React.forwardRef<TRefElement, TProps>((props, ref) => (
        //@ts-ignore
        <WithRouter {...props} forwardRef={ref} />
    ));

    const name = WrappedComponent.displayName || WrappedComponent.name;
    WithRouterRef.displayName = `WithRouterRef(${name})`;

    return WithRouterRef;
}

export default withRouterRef;
